import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'ihp-bloom-redux/app/redux';
import { useGetAllProfileParticipantTasksQuery } from 'ihp-bloom-redux/features/tasks/participantTaskApiSliceV3';
import { setParticipantTasks } from 'ihp-bloom-redux/features/tasks/tasksSlice';

import { filterParticipantTasks, formatParticipantTasks } from 'utils/tasks';
import { EmptyList } from '../Empty';
import { Box, CircularProgress, Typography } from '@mui/material';
import Button from 'ihp-components/components/v2/Button';
import { ReactComponent as ArrowForwardIcon } from 'images/Task/arrow-forward-icon.svg';
import { isFilterApplied } from 'pages/Activities/utils';

function UpcomingActivities({
  personId,
  studyRoleId,
  renderActivities,
  filtersConfig,
  maxVisible,
  isMobile,
  onViewMore,
  disableLoadMore,
}) {
  const dispatch = useDispatch();
  const { selectedTypes = [], startDate, endDate } = filtersConfig;
  const taskTypes =
    selectedTypes[0] === 'show_all' ? null : selectedTypes.join(',');
  const [tasks, setTasks] = useState([]);
  const [prevFilters, setPrevFilters] = useState({ ...filtersConfig });
  const [pageNum, setPageNum] = useState(1);
  const isFiltersUpdated =
    JSON.stringify(filtersConfig) !== JSON.stringify(prevFilters);
  const { activeAccountProfile } = useSelector((state) => state.user);
  const accountProfileId = activeAccountProfile?.attributes?.profile?.id;

  const query = {
    display_status: 'upcoming',
    task_type: taskTypes,
    'start_date[from]': startDate,
    'start_date[to]': endDate,
    page: isFiltersUpdated ? 1 : pageNum,
  };

  const {
    data: response,
    isFetching,
    isLoading,
    refetch,
  } = useGetAllProfileParticipantTasksQuery(
    {
      accountProfileId,
      query: { ...query },
    },
    {
      skip: personId === undefined || studyRoleId === undefined,
    }
  );

  useEffect(() => {
    if (!isFetching && !isLoading) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let filteredTasks = filterParticipantTasks(response?.data || []);
    filteredTasks = formatParticipantTasks(filteredTasks);
    filteredTasks = filteredTasks?.sort(
      (a, b) => (a?.date > b?.date) - (a?.date < b?.date)
    );
    dispatch(setParticipantTasks(filteredTasks));
    setTasks(pageNum === 1 ? [...filteredTasks] : [...tasks, ...filteredTasks]);
  }, [response?.data]);

  useEffect(() => {
    if (JSON.stringify(filtersConfig) !== JSON.stringify(prevFilters)) {
      setPageNum(1);
      setPrevFilters(filtersConfig);
    }
  }, [filtersConfig]);

  function isScrollAtBottom(element) {
    return element.scrollHeight - element.scrollTop === element.clientHeight;
  }

  function handleScroll() {
    if (disableLoadMore) {
      return;
    }

    const totalPages = Math.ceil(
      response?.meta?.total / response?.meta?.per_page
    );
    const elem = document.getElementById('page-main-content');

    if (isScrollAtBottom(elem) && pageNum + 1 <= totalPages) {
      setPageNum(pageNum + 1);
    }
  }

  useEffect(() => {
    const elem = document.getElementById('page-main-content');
    elem.addEventListener('scroll', handleScroll);
    return () => elem.removeEventListener('scroll', handleScroll);
  }, [tasks]);

  if (tasks?.length === 0) {
    return (
      <>
        {isMobile && !isFilterApplied(filtersConfig) ? null : (
          <>
            <EmptyList
              isLoading={isFetching || response === undefined}
              filterApplied={isFilterApplied(filtersConfig)}
              upcoming={true}
            />
          </>
        )}
      </>
    );
  }

  return (
    <Box display={'flex'} flexDirection={'column'}>
      {isMobile && maxVisible && (
        <Typography mb={'20px'} variant='h4'>
          Upcoming Activities
        </Typography>
      )}
      {renderActivities(tasks, isFetching && pageNum === 1, maxVisible)}
      {/* {isMobile && maxVisible && (
        <Button
          onClick={() => onViewMore('UPCOMING')}
          fullWidth
          endIcon={<ArrowForwardIcon width='14px' height='14px' />}
        >
          View All Upcoming
        </Button>
      )} */}
      {/* This loader is for pagination section only*/}
      {isFetching && pageNum > 1 && (
        <CircularProgress sx={{ margin: '50px auto' }} color='primary' />
      )}
    </Box>
  );
}

UpcomingActivities.propTypes = {
  personId: PropTypes.number,
  studyRoleId: PropTypes.number,
  renderActivities: PropTypes.node,
};

export default UpcomingActivities;
